import { create } from 'zustand';
import { persist } from 'zustand/middleware';


const useUserStore = create(
    persist(
        (set) => ({
            user: null,
            isAuthenticated: false,

            setUser: (userData) => set({ user: userData, isAuthenticated: true }),

            clearUser: () => set({ user: null, isAuthenticated: false }),
        }),
        {
            name: 'login-storage', // unique name
            getStorage: () => localStorage // use sessionStorage instead of localStorage

        }
    )
)

export default useUserStore;